{
  "list": {
    "title": "Devices",
    "addNew": "+ New Device",
    "confirm": {
      "delete": "Delete device {{name}} (SN: {{serial}})? Attendance history will be preserved but the terminal will stop being recognized."
    },
    "pendingActivation_one": "{{count}} device awaiting activation.",
    "pendingActivation_other": "{{count}} devices awaiting activation.",
    "failedToLoad": "Failed to load data. Please try again.",
    "empty": "No devices yet. Click + New Device to add one.",
    "activate": "Activate",
    "columns": {
      "serial": "Serial",
      "name": "Name",
      "description": "Description",
      "status": "Status",
      "users": "Users",
      "logs": "Logs",
      "lastSeen": "Last Seen",
      "actions": "Actions"
    },
    "badges": {
      "pending": "Pending",
      "pendingCommands_one": "{{count}} command pending delivery",
      "pendingCommands_other": "{{count}} commands pending delivery"
    },
    "aria": {
      "deactivate": "Deactivate device",
      "activate": "Activate device",
      "notManaged": "You don't manage this device"
    }
  },
  "detail": {
    "accessDenied": "Access denied",
    "accessDeniedHint": "You don't have permission to view this device.",
    "backToDevices": "Back to Devices",
    "notFound": "Device not found",
    "failedToLoad": "Failed to load device. Please try again.",
    "breadcrumb": "Devices",
    "importAll": "Import all from terminal",
    "importing": "Importing…",
    "exportAll": "Export all to terminal",
    "exporting": "Exporting…",
    "pushSettings": "Push all settings now",
    "pushingSettings": "Pushing…",
    "pushSettingsSuccess_one": "{{count}} command queued on the terminal.",
    "pushSettingsSuccess_other": "{{count}} commands queued on the terminal.",
    "pendingCommands_one": "{{count}} command pending delivery to terminal",
    "pendingCommands_other": "{{count}} commands pending delivery to terminal",
    "addExisting": "+ Add existing",
    "addNew": "+ New Employee",
    "editDevice": "Edit Device",
    "clearHistory": "Clear history on terminal",
    "clearing": "Clearing…",
    "ownerLabel": "Owner:",
    "lastSeenLabel": "Last seen:",
    "employees": "Employees",
    "searchPlaceholder": "Search...",
    "failedToLoadEmployees": "Failed to load employees. Please try again.",
    "noEmployeesSearch": "No employees match your search.",
    "noEmployeesEmpty": "No employees enrolled on this device yet.",
    "columns": {
      "deviceUserId": "Device User ID",
      "name": "Name",
      "role": "Role",
      "card": "Card",
      "status": "Status",
      "lastSynced": "Last Synced",
      "lastSeenHere": "Last seen here",
      "syncState": "Sync state"
    },
    "syncBadges": {
      "synced": "Synced",
      "sent": "Sent",
      "pending": "Pending",
      "removing": "Removing",
      "removed": "Removed"
    },
    "actions": {
      "edit": "Edit",
      "export": "Export",
      "unenroll": "Unenroll"
    },
    "confirm": {
      "importAll": "Import all employees from terminal? This will overwrite local data for any matching records.",
      "exportAll": "Export all employees to terminal? This will push all active employees to the device.",
      "clearHistory": "Clear all punch history on the terminal? This cannot be undone.",
      "unenroll": "Remove this employee from the device?",
      "importQueue": "Queue a DATA QUERY command to pull all users from this terminal?",
      "exportAllDetail": "Push all enrolled employees (USERINFO + photos + biometric templates) to this terminal?",
      "clearHistorySwipes": "This will permanently delete all swipe history stored on terminal \"{{name}}\".\n\nLocal records in this app are preserved.\n\nProceed?",
      "clearHistoryPhotos": "Also delete attendance photos from the terminal?\n\nClick OK to also clear photos, Cancel to keep them.",
      "unenrollDetail": "Unenroll \"{{name}}\" (PIN {{pin}}) from this device?\n\nThe employee and their attendance history will not be deleted. A DATA DELETE USERINFO command will be queued."
    },
    "unenrollFailed": "Unenroll failed. Please try again.",
    "importQueued": "Queued {{count}} command(s). {{message}}",
    "importFailed": "Import failed. Check that the terminal is online.",
    "exportQueued": "Export queued for {{employees}} employee(s):\n• {{userinfo}} user records\n• {{userpic}} photos\n• {{biometric}} biometric templates\n\n{{message}}",
    "exportFailed": "Export failed.",
    "clearHistoryFailed": "Clear history failed.",
    "pushSettingsFailed": "Push settings failed.",
    "exportOneQueued": "Queued for {{name}} (PIN {{pin}}) on {{devices}} device(s).",
    "titlePullUsers": "Pull users, photos and biometric templates from this terminal",
    "titleRestoreDB": "Restore local DB + MinIO contents to this terminal",
    "titlePushSettings": "Push all saved hardware settings to the terminal",
    "titleWipeHistory": "Wipe attendance history stored on the terminal. Local DB is preserved.",
    "roleFallbackUser": "User",
    "aria": {
      "searchEmployees": "Search employees",
      "loadingEmployees": "Loading employees..."
    }
  },
  "editDialog": {
    "titleNew": "New device",
    "titleEdit": "Edit device — {{name}}",
    "serialLabel": "Serial Number",
    "serialHint": "Bound to the physical terminal. Cannot be changed.",
    "nameLabel": "Name",
    "descriptionLabel": "Description (optional)",
    "descriptionPlaceholder": "Location or notes about this terminal…",
    "ownerLabel": "Owner",
    "activeLabel": "Active",
    "saveFailed": "Save failed",
    "hardware": {
      "title": "Hardware settings",
      "tzAdj": "Timezone offset (min from UTC)",
      "verifyMode": "Verify mode",
      "verifyModeOptions": {
        "0": "Any method (default)",
        "1": "Fingerprint only",
        "4": "Card only",
        "6": "Fingerprint or card",
        "15": "Face only"
      },
      "verifyModeHint": "Applies to every employee enrolled on this terminal; their records are re-sent to the device when the mode changes.",
      "lockOn": "Lock relay duration (s)",
      "volume": "Speaker volume",
      "idlePower": "Idle power-off (min, 0 = off)",
      "idleMinute": "Sleep-mode timer (min, 0 = off)",
      "lockFun": "Door-lock function",
      "punchAlarm": "Punch alarm advance (min)",
      "mustEnroll": "Require enrolled users only"
    }
  },
  "enrollDialog": {
    "title": "Add existing employees",
    "searchPlaceholder": "Search by name or PIN...",
    "allEnrolled": "All employees are already enrolled on this device.",
    "noResults": "No employees match your search.",
    "noneSelected": "None selected",
    "countSelected_one": "{{count}} selected",
    "countSelected_other": "{{count}} selected",
    "enrolling": "Enrolling…",
    "enroll_one": "Enroll {{count}}",
    "enroll_other": "Enroll {{count}}",
    "columns": {
      "pin": "PIN",
      "name": "Name"
    },
    "enrollFailed": "Enrollment failed",
    "enrollSuccess_one": "Enrolled {{count}} employee. Queued {{queued}} command to the terminal.",
    "enrollSuccess_other": "Enrolled {{count}} employees. Queued {{queued}} commands to the terminal."
  },
  "selectTerminalsDialog": {
    "title": "Select terminals",
    "subtitle": "Choose terminals",
    "confirm": "Push",
    "importConfirm": "Import",
    "noActiveTerminals": "No active terminals",
    "selectAll": "Select all",
    "deselectAll": "Deselect all",
    "noneSelected": "None selected",
    "countSelected_one": "{{count}} selected",
    "countSelected_other": "{{count}} selected"
  },
  "terminalUsers": {
    "title": "Employees",
    "importAll": "Import all from terminal",
    "exportAll": "Export all to terminal",
    "addNew": "+ New Employee",
    "searchPlaceholder": "Search by name or PIN…",
    "filters": {
      "status": "Status",
      "statusAll": "All",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "role": "Role",
      "roleUser": "User",
      "roleAdmin": "Admin",
      "roleSuperAdmin": "Super Admin",
      "device": "Device",
      "hasDevice": "Has device",
      "noDevice": "No device"
    },
    "bulkActions": {
      "selected_one": "{{count}} selected",
      "selected_other": "{{count}} selected",
      "deselectAll": "Deselect all",
      "pushToTerminal": "Push to terminal",
      "pushing": "Pushing…",
      "activate": "Activate",
      "activating": "Activating…",
      "deactivate": "Deactivate",
      "deactivating": "Deactivating…",
      "delete": "Delete",
      "deleting": "Deleting…"
    },
    "empty": {
      "noEmployees": "No employees yet",
      "noResults": "No results match your current filters. Try adjusting the search or filters above.",
      "noEmployeesHint": "Click + New Employee to add manually, or Import all from terminal to pull from the device.",
      "clearFilters": "Clear filters"
    },
    "failedToLoad": "Failed to load employees",
    "failedToLoadHint": "Check your connection and try again.",
    "columns": {
      "employee": "Employee",
      "role": "Role",
      "pay": "Pay",
      "devices": "Devices",
      "status": "Status",
      "biometrics": "Biometrics"
    },
    "privilegeLabels": {
      "superAdmin": "Super Admin",
      "admin": "Admin",
      "enroller": "Enroller",
      "user": "User"
    },
    "confirm": {
      "bulkDelete": "Delete {{count}} employee(s) from terminal? This cannot be undone.",
      "deleteOne": "Delete \"{{name}}\" (PIN {{pin}}) from terminal?"
    },
    "titlePullUsers": "Pull users, photos and biometric templates from the terminal",
    "titleRestoreDB": "Restore local DB + MinIO contents to the terminal",
    "aria": {
      "searchEmployees": "Search employees",
      "loadingEmployees": "Loading employees…",
      "pushSelected": "Push selected employees to terminal",
      "activateSelected": "Activate selected employees",
      "deactivateSelected": "Deactivate selected employees",
      "deleteSelected": "Delete selected employees",
      "bulkActions": "Bulk actions",
      "filterEmployees": "Filter employees",
      "editEmployee": "Edit employee",
      "pushToTerminal": "Push to terminal",
      "deleteEmployee": "Delete employee"
    },
    "toasts": {
      "pushed_one": "Pushed {{count}} employee to terminal.",
      "pushed_other": "Pushed {{count}} employees to terminal.",
      "activated_one": "Activated {{count}} employee.",
      "activated_other": "Activated {{count}} employees.",
      "deactivated_one": "Deactivated {{count}} employee.",
      "deactivated_other": "Deactivated {{count}} employees.",
      "deleted_one": "Deleted {{count}} employee.",
      "deleted_other": "Deleted {{count}} employees.",
      "deleteFailed": "Delete failed. Please try again.",
      "exportFailed": "Export failed. Please try again.",
      "importFailed": "Import failed. Please try again.",
      "someExportsFailed": "Some exports failed.",
      "importQueued": "Queued {{count}} commands across {{devices}} device(s).",
      "exportAllQueued": "Export queued: {{employees}} employees across {{devices}} device(s).",
      "exportOneQueued": "Queued for {{name}} across {{devices}} device(s)."
    },
    "biometricKinds": {
      "face": "Face",
      "fp": "Fingerprint",
      "palm": "Palm"
    }
  }
}
